import React from "react";
import FilesContainer from "./FilesContainer.js";
import GridContextMenuManager from "./GridContextMenuManager.js";
import PopupContextMenuProvider from "../../../contexts/popupContextMenuContext/popupContextMenuContext.js";

const FullDataView = () => {
  return (
    <PopupContextMenuProvider>
      <GridContextMenuManager />
      <FilesContainer />
    </PopupContextMenuProvider>
  );
};

export default FullDataView;
